export default "__VITE_ASSET__33b5780a__"